import { Box, styled } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
  maxHeight: '40vh',
  marginTop: theme.spacing(2),
  padding: theme.spacing(2),
  paddingTop: theme.spacing(3),
  borderRadius: theme.display.borderRadius,
  backgroundColor: theme.colours.new.white,
  overflowY: 'auto',
  '&:focus-visible': {
    outline: 'none'
  },
}))